import type { ActionPromise } from '../../../../model/issue/issue-increment-planning-types';
import type { IssueId, IssueLink } from '../../../../model/issue/issue-types';
import flagMessages from '../../../../view/flags/messages';
import { errorFlagMeta, type FlagMeta } from '../../meta/flag-meta';

export const ISSUE_LINKS_CREATE = 'state.actions.issue.issue-link.ISSUE_LINK_CREATE' as const;

type IssueLinksCreatePayload = {
	newIssueLinks: Record<IssueId, IssueLink[]>;
};

export type IssueLinkCreateAction = {
	type: typeof ISSUE_LINKS_CREATE;
	payload: IssueLinksCreatePayload;
};
export const issueLinksCreate = (payload: IssueLinksCreatePayload): IssueLinkCreateAction => ({
	type: ISSUE_LINKS_CREATE,
	payload,
});

export const ISSUE_LINK_CREATE_REQUEST =
	'state.actions.issue.issue-link.ISSUE_LINK_CREATE_REQUEST' as const;

type IssueLinkCreateRequestPayload = {
	sourceItemKey: string;
	targetItemKey: string;
	type: number;
};

export type IssueLinkCreateRequestAction = {
	type: typeof ISSUE_LINK_CREATE_REQUEST;
	payload: IssueLinkCreateRequestPayload;
	promise?: ActionPromise;
};

export const issueLinkCreateRequest = (
	payload: IssueLinkCreateRequestPayload,
): IssueLinkCreateRequestAction => ({
	type: ISSUE_LINK_CREATE_REQUEST,
	payload,
});

export const ISSUE_LINK_CREATE_SUCCESS =
	'state.actions.issue.issue-link.ISSUE_LINK_CREATE_SUCCESS' as const;

export type IssueLinkCreateSuccessAction = {
	type: typeof ISSUE_LINK_CREATE_SUCCESS;
};

export const issueLinkCreateSuccess = (): IssueLinkCreateSuccessAction => ({
	type: ISSUE_LINK_CREATE_SUCCESS,
});

export const ISSUE_LINK_CREATE_FAILED =
	'state.actions.issue.issue-link.ISSUE_LINK_CREATE_FAILED' as const;

export type IssueLinkCreateFailedAction = {
	type: typeof ISSUE_LINK_CREATE_FAILED;
};

export const issueLinkCreateFailed = (): IssueLinkCreateFailedAction => ({
	type: ISSUE_LINK_CREATE_FAILED,
});

export const ISSUE_LINKS_REMOVE_REQUEST =
	'state.actions.issue.issue-link.ISSUE_LINKS_REMOVE_REQUEST' as const;

type IssueLinksRemoveRequestPayload = {
	issueId: IssueId;
	issueLink: IssueLink;
};

export type IssueLinkRemoveRequestAction = {
	type: typeof ISSUE_LINKS_REMOVE_REQUEST;
	payload: IssueLinksRemoveRequestPayload;
};

export const issueLinksRemoveRequest = (
	payload: IssueLinksRemoveRequestPayload,
): IssueLinkRemoveRequestAction => ({
	type: ISSUE_LINKS_REMOVE_REQUEST,
	payload,
});

export const ISSUE_LINKS_REMOVE_SUCCESS =
	'state.actions.issue.issue-link.ISSUE_LINKS_REMOVE_SUCCESS' as const;

type IssueLinksRemoveSuccessPayload = {
	issueLinksToRemove: Record<IssueId, string>;
};

export type IssueLinkRemoveSuccessAction = {
	type: typeof ISSUE_LINKS_REMOVE_SUCCESS;
	payload: IssueLinksRemoveSuccessPayload;
};

export const issueLinksRemoveSuccess = (
	payload: IssueLinksRemoveSuccessPayload,
): IssueLinkRemoveSuccessAction => ({
	type: ISSUE_LINKS_REMOVE_SUCCESS,
	payload,
});

export const ISSUE_LINKS_REMOVE_FAILED =
	'state.actions.issue.issue-link.ISSUE_LINKS_REMOVE_FAILED' as const;

export type IssueLinkRemoveFailedAction = {
	type: typeof ISSUE_LINKS_REMOVE_FAILED;
	meta: FlagMeta;
};

export const issueLinksRemoveFailed = (): IssueLinkRemoveFailedAction => ({
	type: ISSUE_LINKS_REMOVE_FAILED,
	meta: errorFlagMeta({
		titleMessage: flagMessages.genericTitle,
		descriptionMessage: flagMessages.genericDescription,
	}),
});

export type Action =
	| IssueLinkCreateAction
	| IssueLinkCreateRequestAction
	| IssueLinkCreateSuccessAction
	| IssueLinkCreateFailedAction
	| IssueLinkRemoveRequestAction
	| IssueLinkRemoveSuccessAction
	| IssueLinkRemoveFailedAction;
